import * as React from "react";

// The Level Context can be used inside of <Section /> nodes to nest the level
// of the content. This is useful for when we want to display a hierarchy of
// nested standards within a subtree as a list of cards with trees of standards.

// Every time you want to level to increase, use a `<Section />` node.  The
// components can then use React.useContext(LevelContext) to get the current
// level and do what they wish with it.  This could be the level of indentation
// or the level of a heading or anything else that needs to know the level

export const LevelContext: React.Context<number> = React.createContext(0);
export function Section({children}: {children: React.ReactNode}) {
    const level = React.useContext(LevelContext);
    return (
        <section>
            <LevelContext.Provider value={level + 1}>
                {children}
            </LevelContext.Provider>
        </section>
    );
}
